import { useState } from "react";
import { Flex } from "styled-system/jsx";
import { EnumProductType } from "gql/generated";
import { useDatesAndGuests } from "./useDatesAndGuests";
import { useBookerContext } from "widgets/booker/contexts";
import { ActionCard, CollapsableStep } from "widgets/booker/shared";
import {
  getDatesSummaryString,
  getGuestSummaryString,
} from "widgets/booker/shared/utils";
import { DatesPage, GuestsPage } from "widgets/booker/features/OverlayPages";
import { useTranslation } from "react-i18next";

export const DatesAndGuests = () => {
  const [isDatesOpen, setIsDatesOpen] = useState(false);
  const [isGuestsOpen, setIsGuestsOpen] = useState(false);
  const {
    complete,
    onUpdateDates,
    onUpdateGuests,
    onUpdateGuestNames,
    dates,
    guests,
    guestNames,
    completeDates,
    completeGuests,
    resetDates,
    resetGuests,
  } = useDatesAndGuests(isGuestsOpen);
  const { product, readOnlySelection } = useBookerContext();

  const { t } = useTranslation("booker");

  if (
    product?.type === EnumProductType.Fee ||
    product?.type === EnumProductType.Merch
  ) {
    return null;
  }

  return (
    <CollapsableStep
      title={t("DATES_AND_GUESTS")}
      complete={Object.values(complete).every(v => !!v)}
      stepId="dates-and-guests"
    >
      <Flex flexDir="column" gap="150">
        <ActionCard
          mainText={t("DATES_PAGE.TITLE")}
          subText={getDatesSummaryString(dates, t("DATES_PAGE.SELECT_DATES"))}
          visual={complete.dates ? "success" : "neutral"}
          locked={readOnlySelection}
          onClick={() => setIsDatesOpen(true)}
        />
        <DatesPage
          open={isDatesOpen}
          onClose={() => setIsDatesOpen(false)}
          selectedDates={dates}
          onUpdateDates={onUpdateDates}
          completeDates={completeDates}
          resetDates={resetDates}
        />
        <ActionCard
          mainText={t("GUESTS_PAGE.TITLE")}
          subText={getGuestSummaryString(
            guests,
            product?.pricing?.tiers ?? [],
            t,
          )}
          visual={complete.guests ? "success" : "neutral"}
          locked={readOnlySelection}
          onClick={() => setIsGuestsOpen(true)}
        />
        <GuestsPage
          open={isGuestsOpen}
          onClose={() => setIsGuestsOpen(false)}
          guests={guests}
          guestNames={guestNames}
          onUpdateGuests={onUpdateGuests}
          onUpdateGuestNames={onUpdateGuestNames}
          completeGuests={completeGuests}
          resetGuests={resetGuests}
        />
      </Flex>
    </CollapsableStep>
  );
};
